import { usePageTracking } from "react-event-tracker";
import { VerifyEmailPage } from "./VerifyEmailPage";

export const VerifyEmail = (props) => {
  usePageTracking({
    page: {
      pageType: "input-page",
      siteSection: "registration",
      siteSubSection: "",
      pageTitle: "verification",
    },
    user: {
      authenticationStatus: "not logged in",
    },
  });
  return <VerifyEmailPage {...props} />;
};
